/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AcknowledgeTalentRecommendation } from '@coin/shared/core/util-models-v2';
import { CreateTalentRecommendation } from '@coin/shared/core/util-models-v2';
import { DeleteTalentRecommendations } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfSuccessionManagementActivityStream } from '@coin/shared/core/util-models-v2';
import { PageOfTalentEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfTalentPoolDetails } from '@coin/shared/core/util-models-v2';
import { PageOfTalentReviewEmployee } from '@coin/shared/core/util-models-v2';
import { ReferenceMetaType } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TalentPoolDetails } from '@coin/shared/core/util-models-v2';
import { TalentRecommendation } from '@coin/shared/core/util-models-v2';
import { TalentRecommendationRatio } from '@coin/shared/core/util-models-v2';
import { TalentReviewDashboardValues } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateTalentRecommendation } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface DeleteTalentPoolEmployeesParams {
  id: string;
}

export interface DeleteTalentRecommendationsParams {
  talentPoolTitle?: Array<string>;
  referenceMetaTypes?: Array<string>;
  firstname?: string;
  lastname?: string;
  gid?: string;
  search?: string;
  talentPoolId?: string;
  orgCode?: string;
  orgName?: string;
  placeOfAction?: Array<string>;
  orgCodes?: Array<string>;
  orgNames?: Array<string>;
  recommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  reviewExcluded?: Array<string>;
  areCodes?: Array<string>;
  isWildcardCandidate?: boolean;
  deleteTalentRecommendations?: DeleteTalentRecommendations;
}

export interface ExportTalentPoolEmployeesParams {
  queryTalentPoolTitle?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryAreCodes?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
}

export interface ExportTalentReviewsParams {
  queryTalentPoolTitle?: Array<string>;
  queryReferenceMetaTypes?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  queryReviewExcluded?: Array<string>;
  queryAreCodes?: Array<string>;
  queryIsWildcardCandidate?: boolean;
}

export interface GetAllDetailsTalentPoolsParams {
  queryTitle?: string;
  queryReferenceMetaTypes?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface GetTalentPoolsParams {
  id: string;
}

export interface QueryFieldValuesTalentReviewsParams {
  queryAreCode?: string;
  queryTalentPoolTitle?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: string;
  queryReviewExcluded?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export interface QueryTalentEmployeeActivitiesTalentPoolActivitiesParams {
  id: string;
  page?: number;
  size?: number;
}

export interface QueryTalentPoolActivitiesTalentPoolActivitiesParams {
  id: string;
  page?: number;
  size?: number;
}

export interface QueryTalentPoolEmployeesParams {
  queryTalentPoolTitle?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryAreCodes?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface QueryTalentReviewsParams {
  queryTalentPoolTitle?: Array<string>;
  queryReferenceMetaTypes?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  queryReviewExcluded?: Array<string>;
  queryAreCodes?: Array<string>;
  queryIsWildcardCandidate?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SuccessionManagementPartnerAcknowledgeTalentRecommendationsParams {
  id: string;
  approvalId: string;
  acknowledgeTalentRecommendation?: AcknowledgeTalentRecommendation;
}

export interface SuccessionManagementPartnerCreateTalentRecommendationsParams {
  createTalentRecommendation?: CreateTalentRecommendation;
}

export interface SuccessionManagementPartnerGetTalentRecommendationRatiosParams {
  orgCode?: string;
}

export interface SuccessionManagementPartnerQueryFieldValuesTalentRecommendationRatiosParams {
  targetProperty: 0;
  pagingPage?: number;
  pagingSize?: number;
  orgCode?: string;
}

export interface SuccessionManagementPartnerRevertTalentRecommendationsParams {
  id: string;
  approvalId: string;
}

export interface UpdateTalentRecommendationsParams {
  id: string;
  updateTalentRecommendation?: UpdateTalentRecommendation;
}

@Injectable({
  providedIn: 'root'
})
export class SuccessionManagementPartnerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTalentPoolEmployees(
    requestParameters?: DeleteTalentPoolEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteTalentPoolEmployees(
    requestParameters?: DeleteTalentPoolEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteTalentPoolEmployees(
    requestParameters?: DeleteTalentPoolEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteTalentPoolEmployees(
    requestParameters?: DeleteTalentPoolEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteTalentPoolEmployees', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/succession-management/partner/v1/talent-employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTalentRecommendations(
    requestParameters?: DeleteTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public deleteTalentRecommendations(
    requestParameters?: DeleteTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public deleteTalentRecommendations(
    requestParameters?: DeleteTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public deleteTalentRecommendations(
    requestParameters?: DeleteTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'delete',
      path: `/succession-management/partner/v1/talent-recommendations/delete`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TalentPoolTitle: requestParameters?.talentPoolTitle,
        ReferenceMetaTypes: requestParameters?.referenceMetaTypes,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Gid: requestParameters?.gid,
        Search: requestParameters?.search,
        TalentPoolId: requestParameters?.talentPoolId,
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        PlaceOfAction: requestParameters?.placeOfAction,
        OrgCodes: requestParameters?.orgCodes,
        OrgNames: requestParameters?.orgNames,
        RecommendationState: requestParameters?.recommendationState,
        ReviewExcluded: requestParameters?.reviewExcluded,
        AreCodes: requestParameters?.areCodes,
        IsWildcardCandidate: requestParameters?.isWildcardCandidate
      },
      body: requestParameters?.deleteTalentRecommendations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTalentPoolEmployees(
    requestParameters?: ExportTalentPoolEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTalentPoolEmployees(
    requestParameters?: ExportTalentPoolEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTalentPoolEmployees(
    requestParameters?: ExportTalentPoolEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTalentPoolEmployees(
    requestParameters?: ExportTalentPoolEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-employees/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.RecommendationState': requestParameters?.queryRecommendationState
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTalentReviews(
    requestParameters?: ExportTalentReviewsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTalentReviews(
    requestParameters?: ExportTalentReviewsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTalentReviews(
    requestParameters?: ExportTalentReviewsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTalentReviews(requestParameters?: ExportTalentReviewsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/review-talents/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.ReferenceMetaTypes': requestParameters?.queryReferenceMetaTypes,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.RecommendationState': requestParameters?.queryRecommendationState,
        'Query.ReviewExcluded': requestParameters?.queryReviewExcluded,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.IsWildcardCandidate': requestParameters?.queryIsWildcardCandidate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllDetailsTalentPools(
    requestParameters?: GetAllDetailsTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentPoolDetails>;
  public getAllDetailsTalentPools(
    requestParameters?: GetAllDetailsTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentPoolDetails>>;
  public getAllDetailsTalentPools(
    requestParameters?: GetAllDetailsTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentPoolDetails>>;
  public getAllDetailsTalentPools(
    requestParameters?: GetAllDetailsTalentPoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Title': requestParameters?.queryTitle,
        'Query.ReferenceMetaTypes': requestParameters?.queryReferenceMetaTypes,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalentPools(
    requestParameters?: GetTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentPoolDetails>;
  public getTalentPools(
    requestParameters?: GetTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentPoolDetails>>;
  public getTalentPools(
    requestParameters?: GetTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentPoolDetails>>;
  public getTalentPools(requestParameters?: GetTalentPoolsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getTalentPools', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTalentReviews(
    requestParameters?: QueryFieldValuesTalentReviewsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesTalentReviews(
    requestParameters?: QueryFieldValuesTalentReviewsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesTalentReviews(
    requestParameters?: QueryFieldValuesTalentReviewsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesTalentReviews(
    requestParameters?: QueryFieldValuesTalentReviewsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/review-talents/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.AreCode': requestParameters?.queryAreCode,
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.ReviewExcluded': requestParameters?.queryReviewExcluded,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        TargetProperty: requestParameters?.targetProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentEmployeeActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentEmployeeActivitiesTalentPoolActivitiesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSuccessionManagementActivityStream>;
  public queryTalentEmployeeActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentEmployeeActivitiesTalentPoolActivitiesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSuccessionManagementActivityStream>>;
  public queryTalentEmployeeActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentEmployeeActivitiesTalentPoolActivitiesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSuccessionManagementActivityStream>>;
  public queryTalentEmployeeActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentEmployeeActivitiesTalentPoolActivitiesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('queryTalentEmployeeActivitiesTalentPoolActivities', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/activity-stream/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentPoolActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentPoolActivitiesTalentPoolActivitiesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSuccessionManagementActivityStream>;
  public queryTalentPoolActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentPoolActivitiesTalentPoolActivitiesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSuccessionManagementActivityStream>>;
  public queryTalentPoolActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentPoolActivitiesTalentPoolActivitiesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSuccessionManagementActivityStream>>;
  public queryTalentPoolActivitiesTalentPoolActivities(
    requestParameters?: QueryTalentPoolActivitiesTalentPoolActivitiesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('queryTalentPoolActivitiesTalentPoolActivities', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/activity-stream/talent-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentPoolEmployees(
    requestParameters?: QueryTalentPoolEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentEmployee>;
  public queryTalentPoolEmployees(
    requestParameters?: QueryTalentPoolEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentEmployee>>;
  public queryTalentPoolEmployees(
    requestParameters?: QueryTalentPoolEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentEmployee>>;
  public queryTalentPoolEmployees(
    requestParameters?: QueryTalentPoolEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.RecommendationState': requestParameters?.queryRecommendationState,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentReviews(
    requestParameters?: QueryTalentReviewsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentReviewEmployee>;
  public queryTalentReviews(
    requestParameters?: QueryTalentReviewsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentReviewEmployee>>;
  public queryTalentReviews(
    requestParameters?: QueryTalentReviewsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentReviewEmployee>>;
  public queryTalentReviews(requestParameters?: QueryTalentReviewsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/review-talents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.ReferenceMetaTypes': requestParameters?.queryReferenceMetaTypes,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.RecommendationState': requestParameters?.queryRecommendationState,
        'Query.ReviewExcluded': requestParameters?.queryReviewExcluded,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.IsWildcardCandidate': requestParameters?.queryIsWildcardCandidate,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerAcknowledgeTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementPartnerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerAcknowledgeTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementPartnerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerAcknowledgeTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementPartnerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerAcknowledgeTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const approvalId = requestParameters?.approvalId;
    this.checkRequired('successionManagementPartnerAcknowledgeTalentRecommendations', { id, approvalId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/succession-management/partner/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.acknowledgeTalentRecommendation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerCreateTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementPartnerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerCreateTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementPartnerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerCreateTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementPartnerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerCreateTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/succession-management/partner/v1/talent-recommendations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createTalentRecommendation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerGetDashboardValuesTalentReviews(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentReviewDashboardValues>;
  public successionManagementPartnerGetDashboardValuesTalentReviews(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentReviewDashboardValues>>;
  public successionManagementPartnerGetDashboardValuesTalentReviews(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentReviewDashboardValues>>;
  public successionManagementPartnerGetDashboardValuesTalentReviews(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/review-talents/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerGetTalentRecommendationRatiosParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendationRatio>;
  public successionManagementPartnerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerGetTalentRecommendationRatiosParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendationRatio>>;
  public successionManagementPartnerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerGetTalentRecommendationRatiosParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendationRatio>>;
  public successionManagementPartnerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerGetTalentRecommendationRatiosParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-recommendation-ratio`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public successionManagementPartnerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public successionManagementPartnerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public successionManagementPartnerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementPartnerQueryFieldValuesTalentRecommendationRatiosParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('successionManagementPartnerQueryFieldValuesTalentRecommendationRatios', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-recommendation-ratio/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        TargetProperty: targetProperty,
        OrgCode: requestParameters?.orgCode
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerQueryReferenceMetaTypesTalentPools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<ReferenceMetaType>>;
  public successionManagementPartnerQueryReferenceMetaTypesTalentPools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<ReferenceMetaType>>>;
  public successionManagementPartnerQueryReferenceMetaTypesTalentPools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<ReferenceMetaType>>>;
  public successionManagementPartnerQueryReferenceMetaTypesTalentPools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/partner/v1/talent-pools/reference-meta-types`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementPartnerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerRevertTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementPartnerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerRevertTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementPartnerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerRevertTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementPartnerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementPartnerRevertTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const approvalId = requestParameters?.approvalId;
    this.checkRequired('successionManagementPartnerRevertTalentRecommendations', { id, approvalId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/succession-management/partner/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTalentRecommendations(
    requestParameters?: UpdateTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public updateTalentRecommendations(
    requestParameters?: UpdateTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public updateTalentRecommendations(
    requestParameters?: UpdateTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public updateTalentRecommendations(
    requestParameters?: UpdateTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateTalentRecommendations', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/succession-management/partner/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTalentRecommendation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
